import { apiClient } from "@/core/api/ApiClient";
import { EntityType, WheelOperationDto } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: WheelOperationDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function WheelOperationDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.WheelOperation}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.wheelOperationsApi.apiV1WheelOperationsWheelOperationIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          wheelOperationId: params.entityId,
          isDeleteCascade: params.isDeleteCascade,
        });
      }}
      {...otherProps}
    />
  );
}
